// extracted by mini-css-extract-plugin
export default {"sendMessageButton":"AgentPreviewHeader_sendMessageButton__0IUs1"};